import { Stack } from 'expo-router';
import { View } from 'react-native';

import { AdminSidebar } from '@/components/admin-sidebar';
import { AdminTenantGuard } from '@/components/admin-tenant-guard';

export default function AdminTenantWebLayout() {
  return (
    <AdminTenantGuard>
      <View className="flex-1 flex-row bg-background">
        <AdminSidebar />
        <View className="flex-1">
          <Stack screenOptions={{ headerShown: false }} />
        </View>
      </View>
    </AdminTenantGuard>
  );
}
